import { useReactiveVar } from "@apollo/client";
import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { eventStatusModalVar } from "../../../graphql/globalVar/state";
import { EventStatusEnum } from "../../../types";
import EventStatusControls from "../../eventStatusControls";

const DISPLAY_TO_EVENT_STATUS: Record<string, EventStatusEnum> = {
  APPROVED: EventStatusEnum.Approved,
  DRAFT: EventStatusEnum.Draft,
  MODERATION: EventStatusEnum.ModerationInProgress,
  NEEDS_CHANGES: EventStatusEnum.NeedsChanges,
  FINISHED: EventStatusEnum.Finished,
  PAUSED: EventStatusEnum.Paused,
  archived: EventStatusEnum.Archived,
};

function EventStatusModal() {
  const state = useReactiveVar(eventStatusModalVar);
  const { t } = useTranslation();
  const status = state ? DISPLAY_TO_EVENT_STATUS[state.status] : null;

  return (
    <Modal
      show={status !== undefined && status !== null}
      onHide={() => eventStatusModalVar(null)}
      centered
      dialogClassName="modal-event-status"
      contentClassName="rounded-4 border-0"
    >
      <Modal.Header closeButton className="border-0 p-3 pb-0">
        <Modal.Title className="fw-bold">
          {t("events.detail.statusControls")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-muted p-4 fs-6">
        {state && status && (
          <EventStatusControls status={status} eventId={state.eventId} />
        )}
      </Modal.Body>
    </Modal>
  );
}

export default EventStatusModal;
